import type { ButtonHTMLAttributes, ReactNode } from 'react'

/*
  Button — envuelve `.btn` + `.btn-<variant>` (+ `.btn-sm`) de index.css.
  Acepta todos los props nativos de <button> (onClick, disabled, type, title…).
*/
export type ButtonVariant = 'primary' | 'secondary' | 'danger' | 'ghost' | 'success' | 'link' | 'ai'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant
  size?: 'sm' | 'md'
  children: ReactNode
}

export function Button({ variant = 'secondary', size = 'md', className = '', children, ...rest }: ButtonProps) {
  const cls = ['btn', `btn-${variant}`, size === 'sm' ? 'btn-sm' : '', className]
    .filter(Boolean).join(' ')
  return <button className={cls} {...rest}>{children}</button>
}
